import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const companyDeletedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.COMPANY_DELETED,
        eventTime: new Date().toISOString(),
        data: {
            companyId: '607721d4283e411c6e756501',
        },
    };
};
//# sourceMappingURL=company-deleted.js.map